const buttonsEffect = (btns) => {
    btns.forEach((button) => {
        const text = button.textContent
        const span = document.createElement('span')
        const bubbleSpan = document.createElement('span')
        bubbleSpan.classList.add('button__bubble')
        span.classList.add('button__text')
        span.textContent = text
        button.textContent = ''
        button.appendChild(span)
        button.appendChild(bubbleSpan)
    })
}

export {buttonsEffect}
